<template>
  <el-divider v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </el-divider>
</template>
<script>
export default {
  name: "aia-divider"
};
</script>